import { Inbox } from 'lucide-react';
import { useNotasAguardandoRecebimento } from '@/services/Documentos';
import { linkDaCaixaDeEntrada } from './link-da-caixa-de-entrada';

interface AvisoRecebimentoProps {
  cnpjs: string | null | undefined;
  dataInicio: string | null | undefined;
  dataFim: string | null | undefined;
  /** Muda a cada "Buscar" e "Limpar filtros" da tela (DocumentosContext.aplicacao). */
  aplicacao?: number;
}

/**
 * "N notas aguardando no Recebimento", no topo da aba Entradas (SPEC-018, §3, item 8). Só aparece para quem usa
 * o Recebimento e com pelo menos uma nota aguardando. Os números da tela não mudam: continuam só com as liberadas.
 */
export function AvisoRecebimento({
  cnpjs,
  dataInicio,
  dataFim,
  aplicacao = 0,
}: AvisoRecebimentoProps) {
  const filtro =
    dataInicio && dataFim
      ? {
          cnpj_contribuinte: (cnpjs ?? '').replace(/[^\d,]/g, ''),
          data_emissao_de: dataInicio.slice(0, 10),
          data_emissao_ate: dataFim.slice(0, 10),
        }
      : null;
  const { data } = useNotasAguardandoRecebimento(filtro, aplicacao);
  const aviso = data?.status?.resultado ? data.data : null;

  if (!aviso?.UsaRecebimento || aviso.Quantidade <= 0) {
    return null;
  }

  const quantidade = aviso.Quantidade.toLocaleString('pt-BR');
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
    >
      <span className="flex items-center gap-2">
        <Inbox className="h-4 w-4" />
        {aviso.Quantidade === 1
          ? '1 nota aguardando no Recebimento'
          : `${quantidade} notas aguardando no Recebimento`}
        <span className="text-xs opacity-80">
          — os números desta tela contam só as notas liberadas
        </span>
      </span>
      <a
        className="font-medium underline underline-offset-2"
        href={linkDaCaixaDeEntrada({ cnpjs, dataInicio, dataFim })}
        target="_blank"
        rel="noreferrer"
      >
        Abrir a caixa de entrada
      </a>
    </div>
  );
}
